import styled, { css } from "styled-components";

export const CloseIconWrapperSC = styled.div`
  position: absolute;
  top: -5px;
  right: 0;
  width: 10px;
  height: 10px;
  color: black;
  display: none;
  cursor: pointer;
`;

export const WordSC = styled.div<{ editing?: string; dragging?: string }>`
  padding: 5px 5px;
  border-radius: 8px;
  cursor: ${({ editing }) => (editing === "true" ? "text" : "grab")};
  min-width: 20px;
  text-align: center;
  position: relative;
  ${({ dragging }) =>
    dragging === "true" &&
    css`
      opacity: 0.5;
      border: 1px black dashed;
    `}

  &:hover {
    background: #e0f7fa;
    ${CloseIconWrapperSC} {
      display: block;
    }
  }
`;

export const InputTextSC = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
`;

export const DropdownContainerSC = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  margin-top: 6px;
  z-index: 100;
  padding: 0;
  white-space: nowrap;
  list-style: none;
`;

export const ISynonymSC = styled.li`
  padding: 5px 15px;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: #f0f0f0;
  }
`;
